module.exports = __webpack_public_path__ + "static/media/vail-thumbnail.ad254cab.jpg";